


export class JanglSelectController {
    $onInit() {
        // validate options.
        if (!this.options || !angular.isArray(this.options))  throw new Error(this.name + ': Options must be an array', this.name);
        this.required = this.required || false;

        this._options = [];
        this.options.forEach((option) => {
            if (!option) return;

            // map arrays of string or numbers to our standard options object. 
            if (angular.isString(option) || angular.isNumber(option)) {
                return this._options.push({key: option, label: option});
            }

            // map array options, use idx 0 as key, and idx 1 as label.
            if (angular.isArray(option)) {
                return this._options.push({key: option[0], label: option[1]});
            }

            if (angular.isObject(option)) {
                if (option.hasOwnProperty('key')) {
                    // push things we expect.
                    if (option.hasOwnProperty('label')) {
                        return this._options.push(angular.copy(option));
                    }
                    // map value to label.
                    if (option.hasOwnProperty('value')) {
                        return this._options.push({key: option.key, label: option.value});
                    }
                }                
            }
            throw new Error(this.name + ': Unsupport options format.', this.options);
        });
    }
}
JanglSelectController.$inject = [];

export default JanglSelectController;


// WEBPACK FOOTER //
// ./app/jangl/jangl-select/controller.js